import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import Button from "../../components/ui/Button";
import ScrollReveal from "../../components/animations/ScrollReveal";

export default function AboutPreview() {
  return (
    <section className="py-20 md:py-28 bg-aura-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <ScrollReveal delay={0.1} className="order-2 lg:order-1">
            <SectionHeading
              overline="Who We Are"
              title="Driven by excellence, built for impact."
              subtitle="Aura International combines strategic marketing, flawless event execution, and business development to help brands stand out in competitive markets."
              align="left"
            />
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="mt-6 font-sans text-aura-text leading-relaxed"
            >
              From corporate events to digital campaigns and interior fit-out projects,
              we deliver premium solutions that reflect your vision.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="mt-8"
            >
              <Button to="/about" variant="outline">
                Learn More About Us
              </Button>
            </motion.div>
          </ScrollReveal>
          <ScrollReveal delay={0.2} className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/3] rounded-sm border border-gold-muted/20 overflow-hidden bg-gold-light/10">
                <img
                  src={`${process.env.PUBLIC_URL || ""}/Images/Logo.jpeg`}
                  alt="Aura International"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-gold-primary/40 rounded-sm pointer-events-none" aria-hidden />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
